import { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { save } from './api-aluno-turma';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { addAlunosTurma, updateAlunosTurma, setAlunoTurma as setAlunoTurmaRedux } from "./actions/actions";
import { confirmAlert } from 'react-confirm-alert';
import CircularProgress from '@mui/material/CircularProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import AlunoTextFieldSelect from '../Aluno/UI/AlunoTextFieldSelect';
import AlunoProfile from '../Aluno/AlunoProfile';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import TextFieldDate from '../UI/TextFieldDate';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import dayjs from 'dayjs';

const useStyles = makeStyles({
    form: {
        width: '100%', // Fix IE 11 issue.
        // marginTop: theme.spacing(1),
    },
    title: {
        flex: '1 1 100%',
        paddingTop: '20px;'
    },
    submit: {
        // margin: theme.spacing(3, 0, 2),
    },
    loading: {
        marginRight: '10px',
        marginLeft: '10px'
    }
});

export default function AlunoTurmaForm() {
    const classes = useStyles();
    const alunoTurmaRedux = useSelector(state => state.alunoTurma);
    const [alunoTurma, setAlunoTurma] = useState(useSelector(state => state.alunoTurma));
    const listResultadoFinal = [
        "APROVADO", "REPROVADO_POR_FREQUENCIA", "REPROVADO_POR_DESEMPENHO"
    ];

    const dispatch = useDispatch();
    const [loadingSave, setLoadingSave] = useState(false);

    useEffect(() => {
        setAlunoTurma(alunoTurmaRedux);
    }, [alunoTurmaRedux]);


    const handleChange = (event) => {
        setAlunoTurma({
            ...alunoTurma,
            [event.target.name]: event.target.value
        })
    }

    const clickSubmit = (event) => {
        event.preventDefault();

        if (!alunoTurma.dataEntrada) {
            toast.error("Preencha a Data de Entrada.", {
                position: "bottom-left"
            });
            return;
        }

        const eNovo = alunoTurma.eNovo;
        setLoadingSave(true);
        save(alunoTurma).then((data) => {
            if (data) {
                if (data.error) {
                    if (data.message === 'Erro: Bimestre nao cadastrado') {
                        handleSaveNoBimestreError();
                    } else if (data.message === 'Erro: Aluno Turma já cadastrado') {
                        handleSaveStudentAlredyRegistered();
                    } else {
                        errorMessage(data.message);
                    }
                } else {
                    toast.success("Salvo com sucesso.", {
                        position: "bottom-left"
                    });
                    if (eNovo) {
                        dispatch(addAlunosTurma(data));
                    } else {
                        dispatch(updateAlunosTurma(data));
                    }
                    dispatch(setAlunoTurmaRedux(data));
                    setAlunoTurma(data);
                }
            }
            setLoadingSave(false);

        })

    }


    const handleSaveNoBimestreError = () => {
        confirmAlert({
            title: 'Erro',
            message: 'A série para esta turma não possui cadastro de bimestres. Cadastre os bimestres antes de inserir alunos na turma.',
            buttons: [
                {
                    label: 'Ok',
                    onClick: () => { }
                }
            ]
        });
    }

    const handleSaveStudentAlredyRegistered = () => {
        confirmAlert({
            title: 'Erro',
            message: 'Aluno já cadastrado na Turma.',
            buttons: [
                {
                    label: 'Ok',
                    onClick: () => { }
                }
            ]
        });
    }


    const handleDataEntrada = (data) => {

        setAlunoTurma({
            ...alunoTurma,
            dataEntrada: dayjs(data)
        });
    }

    const handleDataSaida = (data) => {
        setAlunoTurma({
            ...alunoTurma,
            dataSaida: dayjs(data)
        });
    }

    const handleSwitchChange = name => event => {
        setAlunoTurma((prevState) => ({
            ...prevState,
            [name]: event.target.checked
        }));
    };

    const setAluno = (aluno) => {
        setAlunoTurma({
            ...alunoTurma,
            aluno: aluno
        });
    }

    const handleResultadoFinalChange = (event) => {
        const result = listResultadoFinal.find((rf) => {
            return rf === event.target.value
        });
        setAlunoTurma({
            ...alunoTurma,
            resultadoFinalEnum: result
        });
    }


    return (
        <form onSubmit={clickSubmit}>
            <Grid container spacing={2}>
                <Grid size={12}>
                    {alunoTurma.eNovo ?
                        <AlunoTextFieldSelect
                            aluno={alunoTurma.aluno}
                            setAluno={setAluno}
                        /> :
                        <AlunoProfile aluno={alunoTurma.aluno} />
                    }
                </Grid>
                <Grid size={12}>
                    {!alunoTurma.eNovo ?
                        <TextField
                            variant="outlined"
                            margin="normal"
                            size="small"
                            required
                            label="Número Chamada"
                            name="numeroChamada"
                            onChange={handleChange}
                            value={alunoTurma.numeroChamada || ''}
                        /> :
                        ''}


                </Grid>
                <Grid >
                    <TextFieldDate
                        required
                        label="Data Início"
                        value={alunoTurma && alunoTurma.dataEntrada ? alunoTurma.dataEntrada : null}
                        onChange={handleDataEntrada}

                    />

                </Grid>
                <Grid >
                    {!alunoTurma.eNovo ?
                        <TextFieldDate
                            label="Data Fim"
                            value={alunoTurma && alunoTurma.dataSaida ? alunoTurma.dataSaida : null}
                            onChange={handleDataSaida}
                        />
                        : ''
                    }
                </Grid>
                <Grid size={4}>
                    <FormControl fullWidth>
                        <InputLabel id="enviar-por-label">Resultado Final:</InputLabel>
                        <Select
                            labelId="enviar-por-label"
                            id="enviar-por-label"
                            value={alunoTurma.resultadoFinalEnum}
                            onChange={handleResultadoFinalChange}
                        >
                            <MenuItem value={null}>
                            </MenuItem>
                            {listResultadoFinal.map((rf, index) => (
                                <MenuItem key={index} value={rf}>
                                    {rf}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={12}>
                    {!alunoTurma.eNovo ?
                        <FormControlLabel
                            style={{ display: 'flex' }}
                            control={
                                <Switch
                                    checked={alunoTurma && alunoTurma.ativo ? true : false}
                                    onChange={handleSwitchChange('ativo')}
                                    value={alunoTurma && alunoTurma.ativo ? true : false}
                                />
                            }
                            label="Ativo"
                        /> : ''}
                </Grid>
                <Grid size={12}>
                    <Button

                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        disabled={loadingSave}
                    >
                        {loadingSave && <CircularProgress className={classes.loading} color="primary" size={20} />}
                        Salvar
                    </Button>
                </Grid>
            </Grid>



            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
            }}>

            </div>




        </form>
    );
}